// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"7f39796c","208":"239b0fd4","218":"2685aa79","307":"efee31b3","505":"5245e157","814":"28f8e208"}[chunkId] + ".chunk.js";
};